import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { wldOrLegacyDocUploadResolver } from '@shared/mfe-resolver/wld-or-legacy-doc-upload.resolver';

import { AuthGuard } from './core/guards/auth/auth.guard';
import { ClientDataGuard } from './core/guards/client/client-data.guard';
import { IncapacitatedGuard } from './core/guards/incapacitated/incapacitated.guard';
import { InitStateGuard } from './core/guards/init-state/init-state.guard';

export const minorRoutes: Routes = [
  {
    path: 'minor-transfer',
    children: [
      {
        path: 'overview', // setting us up to change on public site
        loadChildren: () =>
          import('./public/minor-overview/minor-overview.module').then(
            (m) => m.MinorOverviewModule,
          ),
      },
    ],
  },
  {
    path: 'secure/minor-transfer',
    canActivate: [AuthGuard, ClientDataGuard, InitStateGuard, IncapacitatedGuard],
    children: [
      // minor secure pages
      {
        path: 'personal-info',
        loadChildren: () =>
          import('./secure/personal-info/personal-info.module').then((m) => m.PersonalInfoModule),
      },
      {
        path: 'contact-info',
        loadChildren: () =>
          import('./secure/contact-info/contact-info.module').then((m) => m.ContactInfoModule),
      },
      {
        path: 'settlement-fund',
        loadChildren: () =>
          import('./secure/settlement-fund/settlement-fund.module').then(
            (m) => m.SettlementFundModule,
          ),
      },
      {
        path: 'employment',
        loadChildren: () =>
          import('./secure/employment/employment.module').then((m) => m.EmploymentModule),
      },
      {
        path: 'upload',
        resolve: {
          'doc-upload-mfe': wldOrLegacyDocUploadResolver,
        },
        loadChildren: () =>
          import('./secure/document-upload/document-upload.module').then(
            (m) => m.DocumentUploadModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/client-due-diligence/client-due-diligence.module').then(
            (m) => m.ClientDueDiligenceModule,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./secure/selected-accounts/selected-accounts.module').then(
            (m) => m.SelectedAccountsModule,
          ),
      },
      {
        path: 'terms',
        loadChildren: () => import('./secure/terms/terms.module').then((m) => m.TermsModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(minorRoutes)],
  exports: [RouterModule],
})
export class MinorRoutingModule {}
